import { Box, BoxProps, Divider } from '@material-ui/core';

import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Font } from '@/components/shared/components/Font';

interface HorizontalScoreCardProps extends Omit<BoxProps, 'title'> {
  title: string | JSX.Element;
  subtitle: string | JSX.Element;
  value: string | number | JSX.Element;
  icon?: JSX.Element;
  subValue?: string | number | JSX.Element;
  hideDivider?: boolean;
  children?: React.ReactNode;
}

export const HorizontalScoreCard = ({
  title,
  subtitle,
  value,
  icon,
  subValue,
  hideDivider,
  children,
  ...props
}: HorizontalScoreCardProps) => {
  return (
    <CustomPaper fill="paper" style={{ padding: 0 }} boxProps={props}>
      <Box style={{ padding: '12px 16px' }}>
        <Box display={'flex'} flexDirection={'row'} gridGap={16} width={'100%'} style={{ overflow: 'auto hidden' }}>
          {icon && (
            <Box width={24} flexShrink={0}>
              {icon}
            </Box>
          )}
          <Box flexGrow={1} minWidth={0}>
            <Font variant="h5" color="title" className="overflow-text-ellipsis">
              {title}
            </Font>
            <Font display="block" variant="overline" color={'textSecondary'} className="overflow-text-ellipsis">
              {subtitle}
            </Font>
          </Box>
          <Box flexShrink={0} display="flex" flexDirection="column" alignItems="flex-end">
            <Font
              variant="h5"
              color="title"
              align="right"
              style={{ marginBottom: 2 }}
              className="overflow-text-ellipsis"
            >
              <strong>{value}</strong>
            </Font>
            {subValue && (
              <Font variant="h6" color="textSecondary" style={{ marginBottom: -2 }} className="overflow-text-ellipsis">
                {subValue}
              </Font>
            )}
          </Box>
        </Box>
      </Box>
      {children}
      {!hideDivider && <Divider light />}
    </CustomPaper>
  );
};
